{
  "pt": {
    "ai": {
      "assistant": {
        "all_projects": "Todos os projetos",
        "cap": {
          "action": "Iniciar uma nova conversa",
          "message": "Atingiu o limite de conversa."
        },
        "empty_state": {
          "subtitle": "Pergunte-me qualquer coisa sobre os seus clientes",
          "title": "Como posso ajudá-lo?"
        },
        "errors": {
          "budget_reached": "O orçamento mensal de IA para este espaço de trabalho foi atingido. Contacte um administrador para aumentar o limite.",
          "generic": "Algo correu mal. Tente novamente."
        },
        "history": {
          "empty": "Ainda não há conversas anteriores",
          "title": "Conversas anteriores"
        },
        "input": {
          "disclaimer": "Os resultados podem ser imprecisos. Verifique sempre as informações importantes.",
          "hint": "Enter para enviar · Shift+Enter para nova linha",
          "placeholder": "Pergunte sobre os seus clientes..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Como configuro as notificações?",
          "help_project_settings": "Onde encontro as definições do projeto?",
          "open_decisions": "Quais decisões ainda estão em aberto?",
          "unassigned_units": "Quais unidades ainda não têm cliente?"
        },
        "support_cta": {
          "action": "Contactar o suporte",
          "prompt": "Não era a resposta que procurava?"
        }
      },
      "settings": {
        "budget": {
          "description": "Limite mensal de custo para utilização de IA (fase de teste). Recalculado com base no consumo de tokens em todas as conversas deste mês.",
          "free_label": "Orçamento gratuito",
          "override_help": "Deixe vazio para utilizar o valor do pacote ({amount}).",
          "override_label": "Orçamento gratuito personalizado",
          "paid_label": "Orçamento pago",
          "save": "Guardar",
          "title": "Orçamento mensal",
          "total_label": "Orçamento total",
          "usage_label": "Utilizado este mês",
          "use_package_amount": "Utilizar o valor do pacote"
        },
        "description": "Configuração das funcionalidades de IA no seu espaço de trabalho.",
        "title": "Definições de IA",
        "usage": {
          "description": "Quanto do saldo de IA deste mês já foi utilizado. Aos 100%, as funcionalidades de IA param até o saldo ser renovado no próximo mês.",
          "title": "Utilização de IA"
        }
      }
    }
  }
}
